module.exports = __webpack_public_path__ + "img/nl.fe4bfff4.svg";